var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGriddy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "29px",
    viewBox: "0 0 90 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EF1DB795-E79E-4C59-A1CC-C8063E8F5CDC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.7234832,7.63882789 C11.7234832,5.57534505 10.2281383,4.16958637 8.10475894,4.16958637 C5.98137955,4.16958637 4.48603466,5.57534505 4.48603466,7.63882789 C4.48603466,9.70241418 5.98137955,11.1080694 8.10475894,11.1080694 C10.2281383,11.1080694 11.7234832,9.70241418 11.7234832,7.63882789 Z M4.93468985,17.1493455 C5.50293125,18.1960352 6.37024163,19.0335525 8.34403481,19.0335525 C10.4375177,19.0335525 11.7234832,17.9567593 11.7234832,15.8333799 L11.7234832,13.2912419 C10.7364832,14.5174144 9.3011383,15.2351385 7.35703478,15.2351385 C3.11037943,15.2351385 0,11.7661039 0,7.63882789 C0,3.51165531 3.11037943,0.0424137948 7.35703478,0.0424137948 C9.3011383,0.0424137948 10.7364832,0.76024141 11.7234832,1.98651732 L11.7234832,0.461172432 L16.0899317,0.461172432 L16.0899317,15.8333799 C16.0899317,20.8578629 12.1721384,22.9812423 8.19455205,22.9812423 C6.84248303,22.9812423 5.58651746,22.760794 4.48551742,22.3101733 C3.05379322,21.7241388 1.88431042,20.7488284 1.10658625,19.362518 L4.93468985,17.1493455 L4.93468985,17.1493455 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0000643%",
    y1: "100%",
    x2: "50.0000643%",
    y2: "0%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81869",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5712A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.00610381,0.058758623 L9.00610381,5.14293124 C7.15189684,4.84375881 4.5199657,5.59148298 4.5199657,8.5522762 L4.5199657,15.311173 L0.0341379324,15.311173 L0.0341379324,0.357724152 L4.5199657,0.357724152 L4.5199657,3.0194484 C5.1182071,1.01565521 7.12200028,0.058758623 9.00610381,0.058758623",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9994235%",
    y1: "100%",
    x2: "49.9994235%",
    y2: "0%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81869",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5712A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.6602763,13.5242074 C11.6602763,11.2811384 10.1650349,9.87548315 8.10134515,9.87548315 C6.03775886,9.87548315 4.54251742,11.2811384 4.54251742,13.5242074 C4.54251742,15.767173 6.03775886,17.1727248 8.10134515,17.1727248 C10.1650349,17.1727248 11.6602763,15.767173 11.6602763,13.5242074 Z M16.146311,21.0008284 L11.6602763,21.0008284 L11.6602763,19.5952766 C10.6733797,20.7317594 9.2079314,21.4195871 7.20413822,21.4195871 C3.28644841,21.4195871 0.0563793126,17.9802421 0.0563793126,13.5242074 C0.0563793126,9.06796588 3.28644841,5.62862091 7.20413822,5.62862091 C9.2079314,5.62862091 10.6733797,6.31665542 11.6602763,7.45303478 L11.6602763,0.0660000026 L16.146311,0.0660000026 L16.146311,21.0008284 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81869",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5712A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.670828,13.5242074 C11.670828,11.2811384 10.1754832,9.87548315 8.11179343,9.87548315 C6.04831059,9.87548315 4.5529657,11.2811384 4.5529657,13.5242074 C4.5529657,15.767173 6.04831059,17.1727248 8.11179343,17.1727248 C10.1754832,17.1727248 11.670828,15.767173 11.670828,13.5242074 Z M16.1568627,0.0660000026 L16.1568627,21.0008284 L11.670828,21.0008284 L11.670828,19.5952766 C10.683828,20.7317594 9.21837968,21.4195871 7.21458649,21.4195871 C3.29689668,21.4195871 0.0669310371,17.9802421 0.0669310371,13.5242074 C0.0669310371,9.06796588 3.29689668,5.62862091 7.21458649,5.62862091 C9.21837968,5.62862091 10.683828,6.31665542 11.670828,7.45303478 L11.670828,0.0660000026 L16.1568627,0.0660000026 L16.1568627,0.0660000026 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8585179,0.0473793122 L10.7443453,14.5522764 C9.0695176,19.3073801 6.40789681,21.191587 2.22093112,20.9822077 L2.22093112,16.795242 C4.31431052,16.795242 5.30131056,16.137311 5.95934506,14.3130006 L0.007758621,0.0473793122 L4.94244847,0.0473793122 L8.26210378,9.19882795 L11.0733108,0.0473793122 L15.8585179,0.0473793122",
    id: "path-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100.000055%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81869",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5712A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.023275863,0.0194482766 L0.023275863,13.0417247 L4.52700018,13.0417247 L4.52700018,0.0194482766 C4.52700018,0.0194482766 3.56472428,0.705827614 2.27513802,0.705827614 C0.985655212,0.705827614 0.023275863,0.0194482766 0.023275863,0.0194482766",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81869",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5712A",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Step-1---Complete---No-Offer---Emoji-2---Email-step-2",
    transform: "translate(-24.000000, -20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(24.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 5.586207)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7234832,7.63882789 C11.7234832,5.57534505 10.2281383,4.16958637 8.10475894,4.16958637 C5.98137955,4.16958637 4.48603466,5.57534505 4.48603466,7.63882789 C4.48603466,9.70241418 5.98137955,11.1080694 8.10475894,11.1080694 C10.2281383,11.1080694 11.7234832,9.70241418 11.7234832,7.63882789 Z M4.93468985,17.1493455 C5.50293125,18.1960352 6.37024163,19.0335525 8.34403481,19.0335525 C10.4375177,19.0335525 11.7234832,17.9567593 11.7234832,15.8333799 L11.7234832,13.2912419 C10.7364832,14.5174144 9.3011383,15.2351385 7.35703478,15.2351385 C3.11037943,15.2351385 0,11.7661039 0,7.63882789 C0,3.51165531 3.11037943,0.0424137948 7.35703478,0.0424137948 C9.3011383,0.0424137948 10.7364832,0.76024141 11.7234832,1.98651732 L11.7234832,0.461172432 L16.0899317,0.461172432 L16.0899317,15.8333799 C16.0899317,20.8578629 12.1721384,22.9812423 8.19455205,22.9812423 C6.84248303,22.9812423 5.58651746,22.760794 4.48551742,22.3101733 C3.05379322,21.7241388 1.88431042,20.7488284 1.10658625,19.362518 L4.93468985,17.1493455 L4.93468985,17.1493455 Z",
    id: "Fill-1",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(19.344828, 5.689655)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00610381,0.058758623 L9.00610381,5.14293124 C7.15189684,4.84375881 4.5199657,5.59148298 4.5199657,8.5522762 L4.5199657,15.311173 L0.0341379324,15.311173 L0.0341379324,0.357724152 L4.5199657,0.357724152 L4.5199657,3.0194484 C5.1182071,1.01565521 7.12200028,0.058758623 9.00610381,0.058758623",
    id: "Fill-4",
    fill: "url(#linearGradient-6)",
    mask: "url(#mask-5)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.3782081,3.04675874 C30.3782081,1.58131041 31.604484,0.355137945 33.0699323,0.355137945 C34.5352772,0.355137945 35.7613462,1.58131041 35.7613462,3.04675874 C35.7613462,4.51220708 34.5352772,5.73848299 33.0699323,5.73848299 C31.604484,5.73848299 30.3782081,4.51220708 30.3782081,3.04675874",
    id: "Fill-7",
    fill: "#E5712A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(37.551726, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6602763,13.5242074 C11.6602763,11.2811384 10.1650349,9.87548315 8.10134515,9.87548315 C6.03775886,9.87548315 4.54251742,11.2811384 4.54251742,13.5242074 C4.54251742,15.767173 6.03775886,17.1727248 8.10134515,17.1727248 C10.1650349,17.1727248 11.6602763,15.767173 11.6602763,13.5242074 Z M16.146311,21.0008284 L11.6602763,21.0008284 L11.6602763,19.5952766 C10.6733797,20.7317594 9.2079314,21.4195871 7.20413822,21.4195871 C3.28644841,21.4195871 0.0563793126,17.9802421 0.0563793126,13.5242074 C0.0563793126,9.06796588 3.28644841,5.62862091 7.20413822,5.62862091 C9.2079314,5.62862091 10.6733797,6.31665542 11.6602763,7.45303478 L11.6602763,0.0660000026 L16.146311,0.0660000026 L16.146311,21.0008284 Z",
    id: "Fill-8",
    fill: "url(#linearGradient-9)",
    mask: "url(#mask-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(56.172416, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.670828,13.5242074 C11.670828,11.2811384 10.1754832,9.87548315 8.11179343,9.87548315 C6.04831059,9.87548315 4.5529657,11.2811384 4.5529657,13.5242074 C4.5529657,15.767173 6.04831059,17.1727248 8.11179343,17.1727248 C10.1754832,17.1727248 11.670828,15.767173 11.670828,13.5242074 Z M16.1568627,0.0660000026 L16.1568627,21.0008284 L11.670828,21.0008284 L11.670828,19.5952766 C10.683828,20.7317594 9.21837968,21.4195871 7.21458649,21.4195871 C3.29689668,21.4195871 0.0669310371,17.9802421 0.0669310371,13.5242074 C0.0669310371,9.06796588 3.29689668,5.62862091 7.21458649,5.62862091 C9.21837968,5.62862091 10.683828,6.31665542 11.670828,7.45303478 L11.670828,0.0660000026 L16.1568627,0.0660000026 L16.1568627,0.0660000026 Z",
    id: "Fill-11",
    fill: "url(#linearGradient-9)",
    mask: "url(#mask-11)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(73.965520, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8585179,0.0473793122 L10.7443453,14.5522764 C9.0695176,19.3073801 6.40789681,21.191587 2.22093112,20.9822077 L2.22093112,16.795242 C4.31431052,16.795242 5.30131056,16.137311 5.95934506,14.3130006 L0.007758621,0.0473793122 L4.94244847,0.0473793122 L8.26210378,9.19882795 L11.0733108,0.0473793122 L15.8585179,0.0473793122",
    id: "Fill-14",
    fill: "url(#linearGradient-14)",
    mask: "url(#mask-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(30.931036, 8.068966)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.023275863,0.0194482766 L0.023275863,13.0417247 L4.52700018,13.0417247 L4.52700018,0.0194482766 C4.52700018,0.0194482766 3.56472428,0.705827614 2.27513802,0.705827614 C0.985655212,0.705827614 0.023275863,0.0194482766 0.023275863,0.0194482766",
    id: "Fill-17",
    fill: "url(#linearGradient-17)",
    mask: "url(#mask-16)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGriddy);
export default __webpack_public_path__ + "static/media/griddy.c7774078a8e47a65f15c0fd82d8ee00c.svg";
export { ForwardRef as ReactComponent };